import { render, staticRenderFns } from "./MultipleChoiceQuiz.vue?vue&type=template&id=0daf5648&"
import script from "./MultipleChoiceQuiz.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports